import SuccessDomainTransfer from "components/SuccessDomain/SuccessDomainTransfer";
import { useQuery } from "helpers/utils";
import { queryDomainTransfer } from "features/domain/domainsSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
// import custom from "../../../assets/scss/Domain.module.scss"; // File sudah dihapus
import { notifyWarning } from "components/ToastMessage";

const validateDomain = (domainInput, extensionTransfer, setTransferButton) => {
  const kamus = [
    "togel",
    "judi",
    "sex",
    "porn",
    "bugil",
    "bokep",
    "xxx",
    "kontol",
    "casino",
    "kasino",
  ];

  const whitelist = [
    "camillajava",
    "javaleap",
    "unigoldtechnology",
    "livelifebetter",
    "sirajudinhasbi",
    "javapustaka",
    "lajudigital",
    "westjava-shizuoka",
    "betariko",
    "tipjavatransport",
  ];

  const validateSingleDomain = (domainName) => {
    const badWord = kamus.some((str) => domainName.includes(str));
    const whiteWord = whitelist.some((str) => domainName.includes(str));

    if (badWord && !whiteWord) {
      notifyWarning("Domain Anda mengandung kata terlarang!");
      setTransferButton(false);
      return false;
    }

    if (domainName.length < 2) {
      notifyWarning("Nama domain minimal 2 karakter!");
      setTransferButton(false);
      return false;
    }

    if (!domainName) {
      notifyWarning("Domain Anda kosong!");
      setTransferButton(false);
      return false;
    }

    if (!extensionTransfer) {
      notifyWarning("Ekstensi Anda kosong!");
      setTransferButton(false);
      return false;
    }

    if (/[<> !@#$%^&*()_+=;:?/\\|}{\][~`]/.test(domainName)) {
      notifyWarning("Domain Anda tidak valid!");
      setTransferButton(false);
      return false;
    }

    return true;
  };

  if (Array.isArray(domainInput)) {
    return domainInput.every((domain) => validateSingleDomain(domain));
  } else {
    return validateSingleDomain(domainInput);
  }
};

const TransferDomain = (props) => {
  const { domainMethod, setDomainMethod, onToggleDomainSections } = props;
  const { status } = useSelector((state) => state.domain);
  const dispatch = useDispatch();
  const query = useQuery();
  const domainTransfer = query.domaintransfer;
  
  const [extOption, setExtOption] = useState([]);
  const [extension, setExtension] = useState("");
  const [domain, setDomain] = useState("");
  const [transferButton, setTransferButton] = useState(false);

  // Fetch domain extensions
  useEffect(() => {
    fetch(`${process.env.REACT_APP_QWORDS_API}api/domain.php?_type=query`)
      .then((response) => response.json())
      .then((val) => setExtOption(val))
      .catch((error) => {
        console.error('Error fetching domain extensions:', error);
        setExtOption([]);
      });
  }, []);

  // Function to handle domain sections toggle
  const handleToggleDomainSections = (shouldShow) => {
    if (onToggleDomainSections && typeof onToggleDomainSections === 'function') {
      onToggleDomainSections(shouldShow);
    }
    
    // If showing sections, focus on the domain input after a short delay
    if (shouldShow) {
      setTimeout(() => {
        const domainInput = document.querySelector('input[placeholder="Nama Domain Anda"]');
        if (domainInput) {
          domainInput.focus();
          domainInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    }
  };

  const searchDomain = (e) => {
    setTransferButton(true);
    e.preventDefault();

    const isValid = validateDomain(domain, extension, setTransferButton);
    if (!isValid) return;

    dispatch(queryDomainTransfer(domain + extension));
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_QWORDS_API}api/domain.php?_type=query`)
      .then((data) => data.json())
      .then((val) => setExtOption(val));
  }, []);

  useEffect(() => {
    if (domainTransfer) {
      const splitDomain = domainTransfer.split(".");
      const domainName = splitDomain[0];
      const extensionTransfer = splitDomain[1];

      const isValid = validateDomain(domainName, extensionTransfer, setTransferButton);
      if (!isValid) return;

      dispatch(queryDomainTransfer(domainTransfer));
    }
  }, [domainTransfer, dispatch, setTransferButton]);

  const options = (extOption || []).map(function (option) {
    // Handle both old and new API response formats
    if (Array.isArray(option) && option.length >= 5) {
      // New format: [id, extension, category, price1, price2, description, requirements, expiry]
      return { 
        value: option[1], // Extension (.abogado)
        label: option[1], // Extension (.abogado)
        price: option[3]  // Price (473000)
      };
    } else if (typeof option === 'object' && option.extension) {
      // Old format: {extension: ".com", price: "100000"}
      return { 
        value: option.extension, 
        label: option.extension, 
        price: option.price 
      };
    } else {
      // Fallback for unexpected format
      console.warn('Unexpected domain extension format:', option);
      return { value: '', label: '', price: '0' };
    }
  }).filter(option => option.value && option.value !== ''); // Filter out empty options

  const handleExtension = (e) => {
    if (!e) {
      setExtension("");
      return;
    }
    setExtension(e.value);
  };

  useEffect(() => {
    if (status !== "loading") {
      setTransferButton(false);
    }
  }, [status]);

  const setDomainHandler = (value) => {
    setDomain(value);
  };

  const handleMethodChange = (e) => {
    setDomainMethod("transfer");
  };

  return (
    <div className="card mb-3 shadow-sm" style={{ minHeight: "100px", borderRadius: "16px", borderColor: "transparent" }}>
      <div className="card-body">
        <div className="form-check mb-3 py-1 px-4">
          <input
            type="radio"
            className="form-check-input"
            name="domainMethod"
            id="transferDomain"
            value="transfer"
            checked={domainMethod === "transfer"}
            onChange={handleMethodChange}
          />
          <label
            htmlFor="transferDomain"
            className="form-check-label fw-bold"
            style={{ fontSize: "18px", marginLeft: "20px" }}
          >
            Transfer domain saya ke Qwords
          </label>
          <p className="mb-0 mt-2" style={{ marginLeft: "21px", marginTop: "6px" }}>
            Migrasi domainmu dari luar Qwords ke sini
          </p>

          {domainMethod === "transfer" && (
            <>
              <form onSubmit={searchDomain} className="mt-3">
                <div className="row g-3">
                  <div className="col-12 col-md-5">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nama Domain Anda"
                      onChange={(e) => setDomainHandler(e.target.value)}
                      value={domain}
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      onChange={handleExtension}
                      isSearchable={true}
                      name="extensions"
                      options={options}
                      isClearable
                      placeholder="Pilih ekstensi..."
                      noOptionsMessage={() => "Tidak ada ekstensi tersedia"}
                      loadingMessage={() => "Memuat ekstensi..."}
                      isLoading={extOption.length === 0}
                      isDisabled={extOption.length === 0}
                      menuPlacement="auto"
                      menuPosition="fixed"
                      maxMenuHeight={200}
                      filterOption={(option, inputValue) => {
                        if (!inputValue) return true;
                        const label = option.label || option.value || '';
                        return label.toLowerCase().includes(inputValue.toLowerCase());
                      }}
                      formatOptionLabel={(option) => {
                        return <span>{option.label}</span>;
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-3">
                    <button
                      className="btn btn-cta w-100 rounded-5"
                      type="submit"
                      disabled={transferButton}
                    >
                      Cek Domain
                    </button>
                  </div>
                </div>
              </form>
              {(domainTransfer || domainMethod === "transfer") && (
                <SuccessDomainTransfer 
                  extensions={extOption} 
                  onToggleDomainSections={handleToggleDomainSections}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransferDomain;
